import Vue from 'vue'
import _ from 'lodash'
import { StylesParser } from '../StylesParser'
import { ConstantsParser } from '../ConstantsParser'
import ArrayManipulation from '../mixins/ArrayManipulation'
export default Vue.extend({
  props: {
    component: {
      type: Object,
      required: true
    },
    parentModule: {
      type: String,
      required: false,
    },
  },
  mixins: [ArrayManipulation],
  data() {
    return {
      childHover: false,
      hover: false
    }
  },
  computed: {
    previewMode() {
      return this.$store.state.previewMode
    },
    family() {
      return 'components'
    },
    content() {
      return this.$store.getters[`${this.module}/content`](this.element)
    },
    device() {
      return this.$store.getters['pageModule/device']
    },
    id() {
      return this.$vnode.key
    },
    element() {
      let key = 'pageComponent'
      let element = {}
      if (this.parentModule) {
        key = 'layoutPageComponent'
      }
      this.$set(element, key, this.pageComponentIndex)
      return element
    },
    pageComponentIndex() {
      return this.$store.getters[`${this.module}/index`](this.id)
    },
    module() {
      if (! this.parentModule) {
        return 'pageComponentModule'  
      }
      return 'layoutPageComponentModule'
    },
    menuOptions() {
      return this.component.properties.menu
    },
    properties() {
      return this.$store.getters[`${this.module}/properties`](this.element)
    },
    parent() {
      return this.$parent
    },
  },
  methods: {
    updateContentProperty: _.debounce(function (property, value) {
      let object = {}
      this.$set(object, property, value)
      this.addToObject(this.module, object, 'content')
    }, 1000),
    classes(classes) {
      return this.$store.getters[`${this.module}/classes`](this.element, classes)
    },
    elementClasses(classes, otherClasses = []) {
      classes = (new ConstantsParser(classes, this.device)).parse()
      return [...classes, ...otherClasses]
    },
    styles(styles) {
      return this.$store.getters[`${this.module}/styles`](this.element, styles)
    },
    elementStyles(styles) {
      return (new StylesParser(styles, this.device)).parse()
    },
  },
})